<div class="envio-firmantes-list table-width" *ngIf="firmantes.length; else sinFirmantes">
  <div class="envio-firmantes-list__header-row" role="row">
    <span class="envio-firmantes-list__h-orden" role="columnheader">Orden</span>
    <div class="envio-firmantes-list__header-flex">
      <span class="envio-firmantes-list__h-drag" role="columnheader" aria-hidden="true"></span>
      <div class="envio-firmantes-list__header-registro">
      <span class="envio-firmantes-list__h-avatar" role="columnheader" aria-hidden="true"></span>
      <span class="envio-firmantes-list__h-campo" role="columnheader">Nombre</span>
      <span class="envio-firmantes-list__h-campo" role="columnheader">Apellido 1</span>
      <span class="envio-firmantes-list__h-campo" role="columnheader">Apellido 2</span>
      <span class="envio-firmantes-list__h-campo envio-firmantes-list__h-campo--email" role="columnheader" *ngIf="mostrarEmail">E-mail</span>
      <span class="envio-firmantes-list__h-campo envio-firmantes-list__h-campo--telefono" role="columnheader" *ngIf="mostrarTelefono">Telefono</span>
      <span class="envio-firmantes-list__h-acciones" role="columnheader" aria-hidden="true"></span>
      </div>
    </div>
  </div>

  <div
    cdkDropList
    class="envio-firmantes-list__drop example-list"
    (cdkDropListDropped)="drop($event)">
    <app-envio-simple-firmante-card
      class="example-box"
      *ngFor="let firmante of firmantes; let i = index; trackBy: trackByCodigo"
      [firmante]="firmante"
      [indice]="i"
      [ocultarOrden]="ocultarOrden"
      [mostrarEmail]="mostrarEmail"
      [mostrarTelefono]="mostrarTelefono"
      [puedeEliminar]="puedeEliminar(firmante)"
      [forzarValidacionContacto]="forzarValidacionContacto"
      [emailDuplicado]="codigosEmailDuplicado.includes(firmante.codigo)"
      [telefonoDuplicado]="codigosTelefonoDuplicado.includes(firmante.codigo)"
      (datosChange)="onDatosChange(firmante.codigo, $event)"
      (buscarEmpleado)="onBuscarEmpleado(firmante)"
      (editarOtrosDatos)="onEditarOtrosDatos(firmante)"
      (eliminar)="onEliminar(firmante)">
    </app-envio-simple-firmante-card>
  </div>

  <div class="envio-firmantes-list__acciones-bottom">
    <div class="envio-firmantes-list__acciones-left">
      <app-boton-accion
        [id]="'anadir-validador'"
        [icono]="'icon-plus'"
        [titulo]="'Añadir validador'"
        [outline]="true"
        [class.envio-firmantes-list__btn-validador--disabled]="!puedeAnadirValidador"
        (click)="onAnadirValidador()">
      </app-boton-accion>
    </div>
    <div class="envio-firmantes-list__canales">
      <div class="envio-firmantes-list__acciones-right">
        <div class="envio-firmantes-list__canal-bloque">
          <label class="envio-firmantes-list__canal-item">
            <input
              type="checkbox"
              [checked]="canalCorreoActivo"
              (change)="onToggleCanalCorreo($any($event.target).checked)" />
            Correo electrónico
          </label>
          <div class="envio-firmantes-list__origen" *ngIf="canalCorreoActivo">
            <app-drop-down-universal-sqp
              class="envio-firmantes-list__origen-dropdown"
              [listaDesplegable]="listaOrigenMail"
              [tituloDropDown]="'E-mail'"
              (seleccionItemSingleOut)="onOrdenMailSeleccionado($event)"
              [modo]="'single'"
              [mostrarIdEnLabel]="false"
              [permitirQuitarFiltro]="false"
              [mostrarBuscador]="false"
              [mostrarTooltipTituloLista]="false"
              [anchuraDesplegable]="240">
            </app-drop-down-universal-sqp>
          </div>
        </div>
        <div class="envio-firmantes-list__canal-bloque">
          <label
            class="envio-firmantes-list__canal-item"
            [class.envio-firmantes-list__canal-item--desactivado]="!moduloSmsActivo">
            <input
              type="checkbox"
              [checked]="canalSMSActivo"
              [disabled]="!moduloSmsActivo"
              (change)="onToggleCanalSMS($any($event.target).checked)" />
            <span [class.desactivado]="!moduloSmsActivo">SMS</span>
            <span *ngIf="!moduloSmsActivo" class="infoSMS tooltip envio-firmantes-list__info-sms">
              <svg class="icon-help" aria-hidden="true">
                <use xlink:href="#hs-help"></use>
              </svg>
              <app-custom-tooltip-sqp [textoTooltip]="'sms'" [posicion]="'left'"></app-custom-tooltip-sqp>
            </span>
          </label>
          <div class="envio-firmantes-list__origen" *ngIf="mostrarTelefono">
            <app-drop-down-universal-sqp
              class="envio-firmantes-list__origen-dropdown"
              [listaDesplegable]="listaOrigenTelefono"
              [tituloDropDown]="'Teléfono'"
              (seleccionItemSingleOut)="onOrdenTelefonoSeleccionado($event)"
              [modo]="'single'"
              [mostrarIdEnLabel]="false"
              [permitirQuitarFiltro]="false"
              [mostrarBuscador]="false"
              [mostrarTooltipTituloLista]="false"
              [anchuraDesplegable]="240">
            </app-drop-down-universal-sqp>
          </div>
        </div>
      </div>
      <span class="texto-validacion envio-firmantes-list__aviso-canales" *ngIf="mostrarAvisoCanales">
        Debes seleccionar al menos un canal de notificación.
      </span>
    </div>
  </div>
</div>

<ng-template #sinFirmantes>
  <p class="envio-firmantes-list__vacio">No hay firmantes en el envío.</p>
</ng-template>
